import { CommonModule } from '@angular/common';
import { Component, ChangeDetectionStrategy, Input } from '@angular/core';
import findKey from 'lodash-es/findKey';

import { Icon, IconFillColor, IconGraphic } from '@design-system/components/atoms/icon/entities/icon.types';
import { DefaultIconViewBox, IconMaxSize, IconViewBoxes } from '@design-system/components/atoms/icon/entities/icon.viewbox';
import { IconGraphics } from '@design-system/components/atoms/icon/entities/icon.graphics';
import { getVectorProps } from '@design-system/components/atoms/icon/helpers/icon.helper';

@Component({
  selector: 'app-ds-icon',
  templateUrl: './icon.component.html',
  styleUrls: ['./icon.component.sass'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [CommonModule]
})
export class IconDsComponent {

  @Input() icon: Icon;
  @Input() color: IconFillColor;
  @Input() size = 24;

  constructor() { }

  get graphics(): IconGraphic[] {
    return IconGraphics?.[this.icon] ?? [];
  }

  get maxSize(): number {
    return IconMaxSize?.[this.icon] ? this.size <= IconMaxSize?.[this.icon] ? this.size : IconMaxSize?.[this.icon] : this.size;
  }

  get viewBox(): string {
    return findKey(IconViewBoxes, (icons) => icons.find(icon => icon === this.icon)) ?? DefaultIconViewBox;
  }

  public vectorProps(g: IconGraphic, c: string): { [key: string]: string } {
    return getVectorProps(g, c);
  }

}
